import Model, { attr } from '@ember-data/model';

export default class ReminderRecord extends Model {
	@attr('string') objectType!: string;
	@attr('number') objectId!: number;

	@attr('number', { defaultValue: 3 }) scheduleType!: number;
	@attr('number', { defaultValue: 9 }) scheduleHourOfDay!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	scheduleDayOfWeek!: number[];
	@attr('number', { defaultValue: -1 }) scheduleDayOfMonth!: number | null;
}
